// import package
import io from "socket.io-client";
import key from "../config/index";
// let connect = false;
const socket = io(key?.API_URL);

const disconnectSocket = (userId) => {
  socket.emit("LOGOUT", userId);
};

const createSocketUser = (userId) => {
  socket.emit("CREATEROOM", userId);
};

export { socket, createSocketUser, disconnectSocket };
